import { c as _c } from "react/compiler-runtime";
import { Box } from "@navikt/ds-react";
export default function TextContentBox(t0) {
  const $ = _c(3);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `max-w-[670] ${className}`;
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <Box className={t2}>{children}</Box>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}